import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./RewardProgressCircle.css";

const RewardProgressCircle = ({ progress }) => {
  return (
    <div className="circular-progress-container">
      <CircularProgressbar
        value={progress}
        text={`${progress}%`}
        strokeWidth={15}
        styles={buildStyles({
          pathColor: "#9c7726", // Progress bar color
          trailColor: "#A4A6B3",  
          // trailColor: "#B8BAC5",
          textColor: "#181818",  // Text color
          textSize: "20px",
          //   fontFamily: `"Poppins",sans-serif`,
          fontWeight: "800",
          strokeLinecap: "butt", // Flat end
        })}
      />
      {/* Create separators around the circle */}
      <div className="circular-separator-container">
        {[...Array(10)].map((_, i) => (
          <div
            key={i}
            className="circular-separator"
            style={{ transform: `rotate(${i * 36}deg)` }}
          />
        ))}
      </div>
    </div>
  );
};

export default RewardProgressCircle;
